import { Controller } from '@hotwired/stimulus'
import { trackSegment } from '../utils/track'

export default class StickyHeaderController extends Controller {
  static targets = ['container']

  fired = false

  trackFirstAppearance() {
    // TODO: Ask for prop values needed for this event
    trackSegment('Static Component Event', {
      component_id: 'sticky-header',
      component_name: 'QLJ Prompt',
      event_name: 'viewed'
    })

    this.fired = true
  }

  connect() {
    this.onScroll()
  }

  shouldShow() {
    return (
      document.documentElement.scrollTop > this.bottomOfFirstDealCard &&
      document.documentElement.scrollTop < this.bottomOfDealTable
    )
  }

  shouldHide() {
    return !this.shouldShow
  }

  onScroll() {
    const firstDealCard = document.querySelector('.dealcard').getBoundingClientRect()
    const dealTable = document.getElementById('table').getBoundingClientRect()
    const scrollTop = document.documentElement.scrollTop

    this.bottomOfFirstDealCard = firstDealCard.top + scrollTop + firstDealCard.height
    this.bottomOfDealTable = dealTable.top + scrollTop + dealTable.height

    if (this.shouldShow()) {
      if (!this.fired) {
        this.trackFirstAppearance()
      }

      this.containerTarget.style.transform = 'translateY(0)'
    } else {
      this.containerTarget.style.transform = 'translateY(-100%)'
    }
  }
}
